import { restApi } from '@icp/settings';

export const CommitContentType = {
  FORM: 'form',
  FLOW: 'flow',
  FRONTEND: 'frontend',
  PAGE: 'page',
  PBC: 'pbc',
};

const COMMIT_TRIGGER_URL_KEY = 'COMMIT_TRIGGER_URL';

export async function getCommitTriggerSetting(projectId) {
  try {
    const cachedCommitTriggerUrl = sessionStorage.getItem(COMMIT_TRIGGER_URL_KEY);
    if (cachedCommitTriggerUrl) {
      return cachedCommitTriggerUrl;
    }
    const result = await restApi.get(`/form/api/project/project-settings/${projectId}`);
    const commitTriggerUrl = result?.client?.commitTriggerUrl;
    if (commitTriggerUrl) {
      sessionStorage.setItem(COMMIT_TRIGGER_URL_KEY, commitTriggerUrl);
    }
    return commitTriggerUrl;
  } catch (e) {
    return null;
  }
}

export async function commit(projectId, type, message, data) {
  const payload = { type, message, data };
  return restApi.post(`/form/api/project/commit/${projectId}`, payload);
}
